@if (!uploadComplete()) {
<app-upload-progression (uploadComplete)="onUploadComplete()" animate.leave="progression-out"
    [class.hide-background]="uploadComplete()" />
}

<div class="preview"
    [style.background-color]="uploadComplete() ? this.colorService.brandSecondary100() : 'transparent'">
    <app-content-preview [class]="uploadComplete() ?  'hide-background' : ''" mode="creation"
        [showData]="!uploadComplete()" [showFooter]="false" />
    @if (uploadComplete()) {
    <h3 animate.enter="fade-slide-in">{{ 'upload.complete.title' | translate }}</h3>
    <p animate.enter="fade-slide-in fade-slide-in-delay">Vous pouvez retrouver son état d'avancement lorem ipsum
        directement
        lorem isum dans l'Historique d'uploads.</p>
    <button class="cta-primary" [routerLink]="['/upload_history']">
        <kin-icon name="eye_on" />
        {{ 'upload.complete.follow_progress' | translate }}
    </button>
    }
</div>